// removed by extract-text-webpack-plugin
module.exports = {"ticketDashboardSearchWrapper":"ticket-dashboard-search-wrapper--1cwSa","selectWrapper":"select-wrapper---AP9q","searchWrapper":"search-wrapper--34P1g"};


//////////////////
// WEBPACK FOOTER
// ./app/components/commons/ticketDashboardSearchBox/ticketDashboardSearchBox.scss
// module id = bdu1
// module chunks = 1